var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var TestService = /** @class */ (function (_super) {
            __extends(TestService, _super);
            function TestService($http, $q) {
                var _this = _super.call(this, $http) || this;
                _this.$q = $q;
                return _this;
            }
            TestService.prototype.getActiveProcessTypes = function () {
                this.handlerUrl = './api/developer/ActiveProcessTypes';
                return this.useGetHandler({});
            };
            TestService.prototype.testAjaxPostException = function () {
                this.handlerUrl = './api/developer/AjaxException';
                return this.usePostHandler({});
            };
            ;
            TestService.prototype.unloadAppPool = function () {
                this.handlerUrl = './api/developer/UnloadApplicationPool';
                return this.usePostHandler({});
            };
            TestService.prototype.clearReportData = function (processTypeId) {
                this.handlerUrl = './api/developer/ClearReportData';
                return this.usePostHandler({ processTypeId: processTypeId });
            };
            TestService.prototype.clearAndRegenReportData = function (processId) {
                this.handlerUrl = './api/developer/ClearAndRegenReportDataForProcess/' + processId;
                return this.usePostHandler({});
            };
            TestService.prototype.regenReportData = function (processTypeId) {
                this.handlerUrl = './api/developer/RegenReportData';
                return this.usePostHandler({ processTypeId: processTypeId });
            };
            TestService.prototype.clearProcessExecutionData = function (vm) {
                this.handlerUrl = './api/developer/ClearProcessExecutionData';
                return this.usePostHandler(vm);
            };
            TestService.prototype.clearProcessCache = function () {
                this.handlerUrl = './api/developer/ClearProcessCache';
                return this.usePostHandler({});
            };
            TestService.prototype.getProcessInfo = function () {
                this.handlerUrl = './api/developer/GetProcessInfo';
                return this.useGetHandler({});
            };
            TestService.prototype.getProcessJson = function (processId) {
                this.handlerUrl = './api/developer/ProcessJson/' + processId;
                return this.useGetHandler({});
            };
            TestService.prototype.getCurrentProcessEventMaxId = function (processId) {
                this.handlerUrl = './api/developer/GetCurrentProcessEventMaxId/' + processId;
                return this.useGetHandler({});
            };
            TestService.prototype.rollbackProcess = function (processId, processEventId) {
                this.handlerUrl = './api/developer/RollbackProcess/' + processId + "/" + processEventId;
                return this.usePostHandler({});
            };
            TestService.prototype.testMemoryFootprint = function (dto) {
                this.handlerUrl = './api/developer/MemoryFootprint';
                return this.usePostHandler(dto);
            };
            TestService.prototype.clearTestItemsFromMemory = function () {
                this.handlerUrl = './api/developer/ClearTestMemory';
                return this.usePostHandler({});
            };
            TestService.prototype.getInWorkProcessConfigs = function () {
                this.handlerUrl = './api/developer/GetInWorkProcessConfigs';
                return this.useGetHandler({});
            };
            TestService.prototype.batchVersionAndActivate = function (model) {
                this.handlerUrl = './api/developer/BatchVersionAndActivate';
                return this.usePostHandler(model);
            };
            TestService.prototype.impersonate = function (userId) {
                this.handlerUrl = "./api/test/Impersonate/" + userId;
                return this.usePostHandler({});
            };
            TestService.prototype.endImpersonation = function () {
                this.handlerUrl = "./api/test/EndImpersonation";
                return this.usePostHandler({});
            };
            TestService.prototype.changeDateTime = function (dto) {
                this.handlerUrl = "./api/test/ProvideOffset";
                return this.usePostHandler(dto);
            };
            TestService.prototype.endChangeDateTime = function () {
                this.handlerUrl = "./api/test/ClearOffset";
                return this.usePostHandler({});
            };
            return TestService;
        }(services.HttpHandlerService));
        services.TestService = TestService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('TestService', ['$http', '$q']);
